import React from 'react';
import PropTypes from 'prop-types';

export default function withDocumentCommonUI(WrappedComponent) {
  class withDocumentCommonUIWrapper extends React.Component {
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  withDocumentCommonUIWrapper.propTypes = {
    onDocumentRejected: PropTypes.func,
    componentId: PropTypes.string,
    document: PropTypes.object
  };

  return withDocumentCommonUIWrapper;
}
